document.addEventListener( 'DOMContentLoaded', function() {
    initSplide();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        initSplide();
      });
    }
});

function initSplide() {
  const splides = document.querySelectorAll('.splide');

    if(splides.length){
        for(let i=0; i<splides.length; i++){
            let minItems = 0;

            const splideElement = splides[i];
            const showHalfItem = splideElement.dataset.showHalfItem;

            let splideDefaultOptions = {
                gap: 10,
                perPage: 6,
                pagination: false,
                breakpoints: {
                  640: {
                    perPage: 2,
                    padding: {
                      right: showHalfItem === 'true' ? '20%' : '0%'
                    },
                  },
                }
            }

            // custom splide date on element
            const splideData = splideElement.dataset.splide;

            if(splideData){
              const splideDataObj = JSON.parse(splideData);
              minItems = splideDataObj.perPage;
            } else {
              minItems = splideDefaultOptions.perPage;
            }

            const items = splideElement.querySelectorAll('.splide__slide');

            // if less items dont show controls
            if(items.length <= minItems){
              const splide = new Splide(splideElement, {
                ...splideDefaultOptions,
                controls: false,
                pagination: false,
                arrows: false,
                drag: false,
                breakpoints: {
                  640: {
                    perPage: 2,
                    drag: true,
                    controls: true,
                    arrows: true,
                  },
                }
              });

              splide.mount();
            } else {
              const splide = new Splide(splideElement, splideDefaultOptions); 

              // adjust padding for half item sliders
              if(showHalfItem === 'true'){
                splide.on('moved', function(newIndex) {
                    if (window.innerWidth <= 640) { // only for mobile
                      const totalSlides = splide.length;
                      const perPage = splide.options.perPage;
                      
                      // remove padding when at the last slide
                      if (totalSlides - newIndex === perPage) {
                          splide.options = { padding: { right: '6%', left: '14%' } };
                      } 

                      // reset padding when at the start of the slider
                      else if (newIndex === 0) {
                          splide.options = { padding: { right: '20%', left: '0%' } };
                      }

                      // restore default padding in between
                      else {
                          splide.options = { padding: { right: '20%', left: '0%' } };
                      }
                    }
                });
              }

              splide.mount();
            }
        }
    }
}
